import type * as React from 'react';

import { CustomNextImage as Image } from '@crehana/next';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Col, Container, type CuiTheme, Row } from '@crehana/ui';
import { useMe } from '@crehana/web/ReactContexts/AuthContext';

import type { CampaignProps } from '@/views/Campaign/types';

import { LeftContainer, Wrapper } from './BottomBanner.styles';
import Countdown from './components/Countdown';
import SignupForm from './components/SignupForm';

const BottomBanner: React.FC<
  React.PropsWithChildren<
    CampaignProps['banner'] & {
      h1?: string;
      logoMobile?: string;
      logoDesktop?: string;
      endDate: string;
    }
  >
> = ({
  backgroundDesktop,
  backgroundMobile,
  logoMobile,
  logoDesktop,
  endDate,
  titleTimer,
  h1,
}) => {
  const { me, loading } = useMe();

  return (
    <Wrapper className="md:flex items-center justify-center py-64 lg:py-0 relative">
      {backgroundMobile ? (
        <div className="md:hidden">
          {/* This syntax requires an imported helper but module 'tslib' cannot be found. */}
          {/* eslint-disable-next-line jsx-a11y/alt-text */}
          <Image src={backgroundMobile} layout="fill" loading="lazy" />
        </div>
      ) : null}
      {backgroundDesktop ? (
        <div className="hidden md:block">
          {/* This syntax requires an imported helper but module 'tslib' cannot be found. */}
          {/* eslint-disable-next-line jsx-a11y/alt-text */}
          <Image src={backgroundDesktop} layout="fill" loading="lazy" />
        </div>
      ) : null}
      <Container className="sm:py-64 md:pt-96 lg:relative">
        <Row className="relative">
          <Col xs={12} md={me ? 12 : 6} className="md:flex items-center">
            <LeftContainer
              className={`text-center mt-16 relative z-2 mr-auto ml-auto mb-52 md:my-auto ${
                me ? 'md:m-auto' : 'md:m-0 '
              }`}
            >
              {logoMobile && (
                <div
                  className="md:hidden mb-40 mt-96 md:mt-56 relative m-auto"
                  css={`
                    width: 250px;
                    height: 70px;
                    ${({ theme }: { theme: CuiTheme }) =>
                      theme.breakpoints.up('sm')} {
                      width: 360px;
                      height: 100px;
                    }
                  `}
                >
                  <Image
                    objectFit="contain"
                    objectPosition="center"
                    alt="Campaign logo"
                    layout="fill"
                    src={logoMobile}
                    loading="lazy"
                  />
                </div>
              )}
              {logoDesktop && (
                <div
                  className="hidden md:block mb-40 m-auto relative"
                  css={`
                    ${({ theme }: { theme: CuiTheme }) =>
                      theme.breakpoints.down('lg')} {
                      width: 360px;
                      height: 100px;
                    }
                    ${({ theme }: { theme: CuiTheme }) =>
                      theme.breakpoints.up('lg')} {
                      width: 420px;
                      height: 120px;
                    }
                  `}
                >
                  <Image
                    alt="Campaign logo"
                    layout="fill"
                    objectFit="contain"
                    objectPosition="center"
                    src={logoDesktop}
                    loading="lazy"
                  />
                </div>
              )}
              <div className="max-w-280 m-auto">
                <Countdown endDate={endDate} titleTimer={titleTimer} />
              </div>
            </LeftContainer>
          </Col>
          {!loading && !me && (
            <Col
              xs={12}
              sm={8}
              md={6}
              offset={{ sm: 2, md: 0 }}
              className="z-2 hidden sm:block md:mt-48"
            >
              <SignupForm title={h1} wrapperClassName="ml-auto lg:m-auto " />
            </Col>
          )}
        </Row>
      </Container>
      <div className="sm:hidden">
        <SignupForm title={h1} wrapperClassName="ml-auto lg:m-auto " />
      </div>
    </Wrapper>
  );
};

export default BottomBanner;
